import { PageTextContentType } from '../../../hooks/useContentMgmt';
import { convertValidationRules } from '../../../hooks/useFormState';
import { validateEmail, validatePhoneNumber } from '../../../util/form-validation';

export interface RegisterFormModel {
  installerPersonId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  pinId: string;
}

type AdditionalContext = {
  content: PageTextContentType;
};

const validateNameField = (error: string, value: any) => {
  return !value.length ? error : null;
};
export const PIN_REGEX = /^[A-Za-z]{2}-[A-Za-z0-9]+$/;

export default convertValidationRules<RegisterFormModel, AdditionalContext>(context => ({
    firstName: validateNameField.bind(null, context.content.get('ENTER_FIRST_NAME')!),
    lastName: validateNameField.bind(null, context.content.get('ENTER_LAST_NAME')!),
    email: validateEmail,
    phoneNumber: validatePhoneNumber, 
    pinId:value =>{
      if(!value) {
        return context.content.get('ENTER_PIN_ID');
      } else if(!PIN_REGEX.test(value)) {
        return context.content.get('ENTER_VALID_PIN_ID');
      }
      return null;
    },
    installerPersonId: validateNameField.bind(null, context.content.get('SELECT_INSTALLER')!),
}));
